import type { CatalogItem } from "@/pages/home/types";

interface TitleCardProps {
  item: CatalogItem;
}

export default function TitleCard({ item }: TitleCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} 影视资源推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs font-medium text-background-50">
          {item.quality}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
        <p className="text-xs text-foreground-600">
          {item.year} · {item.region} · {item.genres.join(" / ")}
        </p>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-700">{item.summary}</p>
        <p className="mt-1 flex items-center gap-1 text-[11px] text-secondary-700">
          <i className="ri-time-line"></i>
          {item.episodes}
        </p>
        <div className="mt-auto flex flex-wrap gap-1 pt-2">
          {item.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}